import React from 'react'

function MoreHorizontalIcon() {
  return (
    <svg
      width='24'
      height='6'
      viewBox='0 0 24 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.3334 3.00016C13.3334 2.26378 12.7364 1.66683 12 1.66683C11.2637 1.66683 10.6667 2.26378 10.6667 3.00016C10.6667 3.73654 11.2637 4.3335 12 4.3335C12.7364 4.3335 13.3334 3.73654 13.3334 3.00016Z'
        stroke='black'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M4.00004 3.00016C4.00004 2.26378 3.40309 1.66683 2.66671 1.66683C1.93033 1.66683 1.33337 2.26378 1.33337 3.00016C1.33337 3.73654 1.93033 4.3335 2.66671 4.3335C3.40309 4.3335 4.00004 3.73654 4.00004 3.00016Z'
        stroke='black'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M22.6667 3.00016C22.6667 2.26378 22.0698 1.66683 21.3334 1.66683C20.597 1.66683 20 2.26378 20 3.00016C20 3.73654 20.597 4.3335 21.3334 4.3335C22.0698 4.3335 22.6667 3.73654 22.6667 3.00016Z'
        stroke='black'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default MoreHorizontalIcon
